import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InvoiceSearchModel } from 'app/core/o2c/inquiries/models/invoice-search-model';
import { InvoicingService } from 'app/core/o2c/processing';
import { PdfViewerDialogComponent } from '../../crud';

@Component({
  standalone: false,
    selector: 'kt-revised-invoice-options',
    templateUrl: './revised-invoice-options.component.html',
    styleUrls: ['./revised-invoice-options.component.scss']
})
export class RevisedInvoiceOptionsComponent implements OnInit {

    /**
     * Invoice data coming from invoice search
     */
    @Input() invoiceData: InvoiceSearchModel;

    /**
     * Variable to hold which PDF should be shown
     */
    action: string;

    constructor(
        private invoicingService: InvoicingService,
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<any>,
    ) {
        this.action = 'standard';
    }

    ngOnInit(): void {
    }

    /**
     * Open the pdf for standard revised invoice
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-10-03
     */
    viewRevisedInvoiceStandard() {
        // To avoid circular dependency we open the modal directly from this instance
        const modalRef = this.dialog.open(PdfViewerDialogComponent, {
            width: '1000px',
            height: '1000px'
        });
        this.invoicingService.generateInvoice([this.invoiceData], false, true)
            .subscribe(
                data => {
                    this.showPdf(modalRef, data, this.invoiceData.invoiceNumber.toString());
                },
            );
    }

    /**
     * Open the pdf for second customer revised invoice
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-10-03
     */
    viewRevisedInvoice2ndCustomer() {
        // To avoid circular dependency we open the modal directly from this instance
        const modalRef = this.dialog.open(PdfViewerDialogComponent, {
            width: '1000px',
            height: '1000px'
        });
        this.invoicingService.generateOfflineInvoice(this.invoiceData.gemDBKey)
            .subscribe(
                data => {
                    this.showPdf(modalRef, data, this.invoiceData.invoiceNumber.toString());
                },
            );
    }

    /**
     * Method to display a pdf in base64 in a blank window
     * @author Castor Transformación Digital - Juan G. Pavas
     * @since 2019-10-31
     * @param data: object that contains a pdf in base64
     */
    private showPdf(modalRef: MatDialogRef<PdfViewerDialogComponent, any>, data: any, invoiceNumber?: string) {
        modalRef.componentInstance.data = data;
        if (invoiceNumber) {
            modalRef.componentInstance.invoiceNumber = invoiceNumber;
        }
    }

    /**
     * Close this modal
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-03-16
     */
    public close() {
        this.dialogRef.close();
    }

    /**
     * Submit action to select which revised invoice standard or second customer
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-10-03
     */
    submit() {
        if (this.action === 'standard') {
            this.viewRevisedInvoiceStandard();
            return;
        }
        this.viewRevisedInvoice2ndCustomer();
    }
}
